import { hasFix, UNABLE_TO_CALCULATE } from '../../../../../shared/vulns/remediation';

type Params = {
  completeFix: string;
  partialFix: string;
  isUserDefinedDependency?: boolean;
};

/** Which remediation cards a vulnerability shows, given its complete and partial fix versions. */
export const getRemediationCardFlags = ({ completeFix, partialFix, isUserDefinedDependency }: Params) => {
  const hasCompleteFix = hasFix(completeFix);
  const hasPartialFix = hasFix(partialFix);

  // always show the complete fix if one is available
  const shouldShowCompleteFix = hasCompleteFix;
  // only show the partial fix if one is available and either:
  // 1. there is no complete fix
  // 2. the complete fix is different version than the partial fix
  const shouldShowPartialFix = hasPartialFix && (!hasCompleteFix || completeFix !== partialFix);
  // only show "no fix" if the vuln has neither a complete fix nor a partial fix
  const shouldShowNoFix = !(hasCompleteFix || hasPartialFix);
  /*
    "Unable to calculate" replaces "no fix" when FOSSA could not work out a fix at
    all, as opposed to NO_SAFE_VERSION where it checked and none exists. partialFix
    drives this, matching useFossabotNoFix, since it is the field about this vuln.
  */
  const shouldShowUnableToCalculate = isUserDefinedDependency
    || (shouldShowNoFix && partialFix === UNABLE_TO_CALCULATE);

  return {
    shouldShowCompleteFix,
    shouldShowPartialFix,
    shouldShowNoFix,
    shouldShowUnableToCalculate,
  };
};
